/**
 * Central API base URL resolver.
 *
 * PROBLEM this solves:
 * The production frontend is served on both `schoolpix.media` (apex) and
 * `www.schoolpix.media`. The compiled `REACT_APP_BACKEND_URL` is a fixed
 * value baked at build time, so if the user lands on the "wrong" host,
 * every API call goes cross-origin and hits an edge 308 redirect. Browsers
 * refuse to follow cross-origin redirects on CORS-tagged requests, so
 * login/theme/etc all fail.
 *
 * FIX: at runtime, if the current window host is under `schoolpix.media`,
 * use the current origin instead of the compiled value. This guarantees
 * same-origin API calls regardless of which subdomain the user is on,
 * eliminating the redirect chain entirely. Non-production hosts (preview,
 * localhost) fall back to the compiled REACT_APP_BACKEND_URL unchanged.
 */

const COMPILED_BASE = process.env.REACT_APP_BACKEND_URL || '';

const isProdHost = (hostname) =>
  hostname === 'schoolpix.media' || hostname.endsWith('.schoolpix.media');

export const API_BASE = (() => {
  if (typeof window === 'undefined' || !window.location) return COMPILED_BASE;
  try {
    if (isProdHost(window.location.hostname)) {
      return window.location.origin;
    }
  } catch (e) {
    // Fall through to the compiled base. Cross-origin iframe scenarios can
    // throw when reading window.location, so this is expected in edge cases.
    // Log at debug level only — a hard error would spam sentry.
    if (typeof console !== 'undefined' && console.debug) {
      console.debug('[apiBase] window.location read failed, using compiled base', e);
    }
  }
  return COMPILED_BASE;
})();

export const API = `${API_BASE}/api`;
